import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { Labels } from 'src/app/app.models';
import { PaymentSdkService } from 'src/app/services/payment-platform-sdk.service';
import { selectDigitalProfileID, selectFirebaseAuthToken } from 'src/app/store/auth/auth.selectors';
import { GetPaymentPlatformMetaData } from 'src/app/store/digital-payment/digital-payment.action';
import { selectQueryParams } from 'src/app/store/query-params';
import { selectDestinationCountryData, selectPaymentPlatformMetaData, selectSendValidateResponse } from 'src/app/store/transaction';

@Component({
    selector: 'app-payment-platform-sdk',
    templateUrl: './payment-platform-sdk.component.html',
    styleUrls: ['./payment-platform-sdk.component.scss'],
    standalone: false
})
export class PaymentPlatformSdkComponent {
  private paymentSDKService: PaymentSdkService = inject(PaymentSdkService)
  removeListenersFn: (() => void) | null = null

  @Output() paymentPlatformSdkCompleteEvent = new EventEmitter<'success' | 'error'>()

  @Input() labels: Labels
  @Input() set launchPaymentPlatformSdk(launch: boolean) { // Todo: Tim: #may6 - this should be a Subject that emits an
    if (launch) {
      const payload = this.buildPaymentPlatformPayload()
      this.store.dispatch(GetPaymentPlatformMetaData({payload: payload, fbAuthToken: this.firebaseAuthToken}))
    }
  }

  private digitalProfileId: string
  private userLanguage: string
  private destinationCountryCode: string
  private amount: string
  private currency: string
  private firebaseAuthToken: string

  destroy$: Subject<void> = new Subject<void>()
  
  constructor(
    private store: Store
  ) {}

  ngOnInit() {
    this.store.select(selectPaymentPlatformMetaData)
      .pipe(takeUntil(this.destroy$))
      .subscribe(paymentPlatformMetaData => {
        if (paymentPlatformMetaData) {
          this.openPaymentModal(paymentPlatformMetaData)
        }
      })

    this.store.select(selectFirebaseAuthToken)
      .pipe(takeUntil(this.destroy$))
      .subscribe(firebaseAuthToken => {
        this.firebaseAuthToken = firebaseAuthToken
      })

    this.store.select(selectDigitalProfileID)
      .pipe(takeUntil(this.destroy$))
      .subscribe(digitalProfileId => {
        this.digitalProfileId = digitalProfileId
      })

    this.store.select(selectQueryParams)
      .pipe(takeUntil(this.destroy$))
      .subscribe(queryParams => {
        this.userLanguage = queryParams.locale
      })

    this.store.select(selectDestinationCountryData)
        .pipe(takeUntil(this.destroy$))
        .subscribe(destinationCountryData => {
          this.destinationCountryCode = destinationCountryData.country!
      })

    this.store.select(selectSendValidateResponse)
      .pipe(takeUntil(this.destroy$))
      .subscribe(sendValidateResponse => {
        if (sendValidateResponse && sendValidateResponse?.sendAmountDetails && sendValidateResponse?.sendAmountDetails?.totalAmount) {
          this.amount = sendValidateResponse.sendAmountDetails.totalAmount.value.toString()
          this.currency = sendValidateResponse.sendAmountDetails.totalAmount.currencyCode
        }
      })
  }

  ngOnDestroy() {
    this.destroy$.next()
    this.destroy$.complete()
  }

  private openPaymentModal(paymentPlatformMetaData: any) { // Todo: Tim: #may6 - fix type
    this.removeListenersFn?.()

    this.paymentSDKService.pay({
      payObj: paymentPlatformMetaData,
      listeners: {
        onLoad: () => {
          console.log('onLoad - debit')
        },
        onError: error => {
          console.log('onError - debit', error)
          this.paymentPlatformSdkCompleteEvent.emit('error')
        },
        onClose: (event) => {
          const status = event?.detail?.success ?? 'error'
          if (status === true) {
            this.paymentPlatformSdkCompleteEvent.emit('success')
          }
          else {
            this.paymentPlatformSdkCompleteEvent.emit('error')
          }
          console.log('onClose - debit')
        },
      },
    })
  }

  private buildPaymentPlatformPayload() {
    return {
      digitalProfileId: this.digitalProfileId,
      userLanguage: this.userLanguage,
      paymentMethod: 'DEBIT_CARD',
      countryCode: this.destinationCountryCode,
      amount: {
        value: this.amount,
        currency: this.currency
      }
    }
  }
}
